var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionSensor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C15.2 12 13 9.8 13 7C13 4.2 15.2 2 18 2C20.8 2 23 4.2 23 7C23 9.8 20.8 12 18 12ZM10 22V30L13 32L14 46H22L23 32L26 30V22C26 17.6 22.4 14 18 14C13.6 14 10 17.6 10 22Z",
    fill: "#EE8003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.7V22C30 17.5 28.6 14.6 26 11.8C26.7 10.3 27 8.6 27 7C27 5.2 26.6 3.5 25.9 2H23.2C24.3 3.4 25 5.1 25 7C25 10 22.9 12.6 22.9 12.6C22.9 12.6 28 14.8 28 22V31.6L24.9 33.7L24 46H26L26.7 35.9L30 33.7Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 7C29 9.3 28.3 11.3 28.3 11.3C28.3 11.3 32 15.6 32 22V35.1L28.6 37.3L28 46H30L30.5 38.4L33.9 36.099V22C33.9 18 32.7 14.2 30.4 10.9C30.8 9.6 31 8.3 31 7C31 5.3 30.7 3.6 30.2 2H28.1C28.7 3.6 29 5.2 29 7Z",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 7C33 8.2 32.9 9.4 32.7 10.5C34.8 14 36 17.9 36 22V37.2L32.5 39.5L32 46H34L34.4 40.7L38 38.3V22C38 17.8 36.9 13.7 34.8 10.1C34.9 9.1 35 8 35 7C35 5.3 34.8 3.6 34.4 2H32.3C32.8 3.6 33 5.3 33 7Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionSensor);
export default __webpack_public_path__ + "static/media/motion-sensor.6d034202aa1ce5ee1f600b2cc730dea2.svg";
export { ForwardRef as ReactComponent };